// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ndiv.warning[data-v-1aa4b7ae] {\n  border: 2px solid darkred;\n  border-radius: 5px;\n  padding: 10px;\n  color: darkred;\n  font-weight:700;\n  margin-left:10px;\n}\ndiv.warning span[data-v-1aa4b7ae] {\n  display:inline-block;\n  width:calc(100% - 60px);\n  margin-left:10px;\n}\n.mtdt-user div.warning i[data-v-1aa4b7ae] {\n  vertical-align:top;\n  margin-top:5px;\n}\n", ""]);
// Exports
module.exports = exports;
